import React from 'react';
import { Route } from 'react-router';
import { DutyScheduleOverview } from '@pages/Portal/DutySchedule/Overview';
import { ROUTES } from '@routes/routes';

export const portalDutyScheduleRoutes = (
  <Route path={ROUTES.portal.dutySchedule.overview}>
    <Route index element={<DutyScheduleOverview />} />
  </Route>
);
